import React from 'react';
import ServiceCarousel from "./ServiceCarousel";
import MessagePopup from "./MessagePopup";
import {useOpenInWindow} from 'use-open-window';
import {updateAnalytics} from "./utils";

class Services extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            serviceTypeList: [],
            serviceDescription: '',
            serviceList: [],
            allowBooking: true,
            bookingUrl: '',
            bookingPhone: '',
            redirects: [],
            serviceType: null,
            showRedirectPopup: [false, false],
            bodyOverflow: false,
            serviceDetails: null
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            serviceType: nextProps.serviceType,
            serviceDetails: nextProps.serviceDetails
        }, function () {
            this.loadData();
        })
    }

    loadData() {
        if (this.props.serviceType === 'Category' || this.props.serviceType === 'Appointment') {
            this.setState({
                serviceTypeList: this.state.serviceDetails && this.state.serviceDetails.service_types,
                serviceDescription: this.state.serviceDetails && this.state.serviceDetails.service_types[0] && this.state.serviceDetails.service_types[0].header,
                serviceList: this.state.serviceDetails && this.state.serviceDetails.service_types[0] && this.state.serviceDetails.service_types[0].packages,
                allowBooking: this.state.serviceDetails && this.state.serviceDetails.allow_booking,
                bookingUrl: this.state.serviceDetails && this.state.serviceDetails.booking_url,
                bookingPhone: this.state.serviceDetails && this.state.serviceDetails.booking_phone,
                redirects: this.state.serviceDetails && this.state.serviceDetails.redirects
            });
        }
        if (this.state.serviceType === 'List') {
            this.setState({
                serviceList: this.state.serviceDetails && this.state.serviceDetails.packages,
                allowBooking: this.state.serviceDetails && this.state.serviceDetails.allow_booking,
                bookingUrl: this.state.serviceDetails && this.state.serviceDetails.booking_url,
                bookingPhone: this.state.serviceDetails && this.state.serviceDetails.booking_phone,
                redirects: this.state.serviceDetails && this.state.serviceDetails.redirects
            });

        }
    }

    componentWillMount() {
        this.setState({
            serviceType: this.props.serviceType,
            serviceDetails: this.props.serviceDetails
        }, function () {
            this.loadData();
        })
    }


    selectCategory = () => {
        if (this.props.serviceType === 'Category' || this.props.serviceType === 'Appointment') {
            return (
                <select className="service-options" onChange={(e) => this.handleServiceSelect(e)}>
                    {this.state.serviceTypeList && this.state.serviceTypeList.map((service, index) => (
                        <option value={service.id}>{service.name}</option>
                    ))}

                </select>
            )
        }
    }


    handleServiceSelect(event) {
        let value = event.target.value;
        let element = this.state.serviceTypeList.find((elem) => value == elem.id)
        this.setState({
            serviceTypeList: this.state.serviceTypeList,
            serviceDescription: element.header,
            serviceList: element.packages
        });
    }

    handleClick = (e, index) => {
        e.preventDefault();
        let showPopup = [false, false];
        showPopup[index] = true
        this.setState({
            showRedirectPopup: showPopup,
            bodyOverflow: true
        })
    }

    closeRedirectModal = () => {
        this.setState({
            showRedirectPopup: [false, false],
            bodyOverflow: false
        })
    }

    showUrlRedirect(redirect, index) {
        return (
            <a href='#' onClick={e => this.handleClick(e, index)} className="btn btn__borderd">
                {redirect.caption}
            </a>
        )

    }

    showAppointmentRedirect(redirect) {
        let pcbID = this.props.PCBID
        return (
            <AppointmentButton caption={redirect.caption} pcbID={pcbID}/>
        )
    }

    showRedirectsList() {
        return (
            this.state.redirects && this.state.redirects.map((redirect, index) => {
                if (this.props.serviceType === 'Appointment') {
                    if (redirect.type === 'url_redirect') {
                        return this.showUrlRedirect(redirect, index)
                    } else if (redirect.type === 'appointments') {
                        return this.showAppointmentRedirect(redirect)
                    }
                } else {
                    return this.showUrlRedirect(redirect, index)
                }

            })
        )
    }

    updateServiceRedirectCount = (index, redirect) => {
        if (this.props.serviceType === 'Appointment') {
            if (index === 0) {
                updateAnalytics('appointment_url_redirect_1', [redirect.id], this.props.PCBID)
            } else if (index === 1) {
                updateAnalytics('appointment_url_redirect_2', [redirect.id], this.props.PCBID)
            }
        } else {
            if (index === 0) {
                updateAnalytics('service_redirect_1', [redirect.id], this.props.PCBID)
            } else if (index === 1) {
                updateAnalytics('service_redirect_2', [redirect.id], this.props.PCBID)
            }
        }
        this.closeRedirectModal();
    }


    render() {
        let pcbID = this.props.PCBID;
        let className = this.props.messageEnabled ? 'wrap-top' : 'wrap-top custom-padding'
        return (
            <section className={className} id="services">
                <div className="content">
                    <h2 className="title" id="serviceHeader"><span>Services</span></h2>
                    <div className="select-service-options">{this.selectCategory()}</div>
                    <p className="sub-title">{this.state.serviceDescription}</p>
                    <ul className="services-list">
                        <ServiceCarousel serviceList={this.state.serviceList}/>
                    </ul>
                    <div className="serivce-btm-btns">
                        {this.showRedirectsList()}
                    </div>
                </div>

                {this.state.redirects && this.state.redirects.map((redirect, index) => (
                        <MessagePopup onClose={this.closeRedirectModal} show={this.state.showRedirectPopup[index]}
                                      setClassName="contactModal">
                            <div className="serivce-btm-btns" style={{display: 'flex', padding: '0% 20%'}}>
                                {
                                    redirect.message && redirect.message.split('\n ').map(i => {
                                        return <p style={{"white-space": "pre-line"}}>{i}</p>
                                    })
                                }
                                <div className="btn-row service-modal-btn flex-box">
                                    <a onClick={this.closeRedirectModal} className="btn modal-btn btn-center btn-secondary"
                                       style={{textTransform: 'none'}}>
                                        Cancel
                                    </a>
                                    <a href={redirect.url} target="_blank"
                                       className="btn modal-btn btn-center btn-secondary" style={{textTransform: 'none'}}
                                       onClick={i => this.updateServiceRedirectCount(index, redirect)}>
                                        Transfer
                                    </a>
                                </div>
                            </div>
                        </MessagePopup>
                    )
                )}

            </section>
        );
    }

}

const AppointmentButton = (props) => {
    const options = {
        url: "https://bookingdemo.petconnectapp.com?pcbId=" + props.pcbID,
        centered: true, /* default */
        specs: {
            width: 1440, /* window width */
            height: 1020, /* window height */
        }
    };

    const [handleWindowOpen, newWindowHandle] = useOpenInWindow();

    function UpdateBookingAppViewCount(event) {
        let data = {type: 'appointment_access'}
        fetch(process.env.REACT_APP_BASE_URL + 'web/' + props.pcbID + '/update_analytics', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        }).then(function (response) {

        });

        handleWindowOpen(event, options)
    }

    return (
        <a onClick={(event) => UpdateBookingAppViewCount(event)} className="btn btn-center btn-secondary"
           style={{marginRight: '15px'}}>
            {props.caption}
        </a>
    );
}


export default Services;